import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from '@/router/routes.js';
import store from '@/store/store';

Vue.use(VueRouter);

const publicPages = ['login', 'mobile-order-checkout', 'mobile-purchase-complete' ]

const router = new VueRouter({
  routes,
  linkActiveClass: 'active'
});

router.beforeEach((to, from, next) => {
  store.commit('routeChange', 'start');
  // scroll to top when changing pages
  if (document.scrollingElement) {
    document.scrollingElement.scrollTop = 0;
  } else if (document.documentElement) {
    document.documentElement.scrollTop = 0;
  }

  store.commit('hideFullScreenNav');

  const isProtectedPage = !publicPages.includes(to.name)
  const token = Vue.$cookies.get('token')
  if (isProtectedPage && !token) {
    next('login')
    return
  }

  next()
});

//= ===change page title after route change

router.afterEach((to, from) => {
  if (to.meta.title) {
    document.title = to.meta.title + ' - ' + store.site_name;
    // set pageTitle to null if it is set manually elsewhere
    store.commit('changePageTitle', to.meta.title);
    store.commit('routeChange', 'end');
  }
});

export default router;
